export default __webpack_public_path__ + "static/media/c27c56ad5ba470e3e761f47929a3b9d71578323811958.b1c31eb8.webp";